(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tenzn-one-page"] && !Shopify.designMode) return;
  try {
    

function initTenzn() {
 document.querySelectorAll('.tz-v2:not([data-initialized])').forEach(root=>{
 root.dataset.initialized='true';
 const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 if('IntersectionObserver' in window && !reduce){
  root.classList.add('motion-ready');
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');observer.unobserve(e.target)}}),{threshold:.08,rootMargin:'0px 0px -15px 0px'});
  root.querySelectorAll('[data-reveal]').forEach(el=>observer.observe(el));
 }
 const state={product:'',colour:'',finish:''};
 const form=root.querySelector('#TenznEnquiry');
 const productSelect=form?.querySelector('#tz-product');
 const productPreviewTypes={
  'T-shirts':'tee',
  'Hoodies':'hoodie',
  'Sweatshirts':'sweatshirt',
  'Polos':'polo',
  'Custom Sports & Performance Jerseys':'jersey',
  'Matching Trousers / Joggers':'joggers',
  'Full Co-ord Sweatsuit Sets (Hoodie + Trouser)':'set'
 };
 const previewSvg=root.querySelector('[data-garment-preview]');
 const previewGroups=Array.from(root.querySelectorAll('[data-preview-type]'));
 const previewProductName=root.querySelector('[data-preview-product]');
 const placementInputs=Array.from(root.querySelectorAll('[data-placement]'));
 const placementMemory=new Map();
 let placementProduct=null;
 let previewSide='front';
 const placementChoiceBox=root.querySelector('[data-placement-choices]');
 const placementCollectionNote=root.querySelector('[data-placement-collection]');
 const placementSummary=form?.querySelector('[data-placement-summary]');
 const placementSummaryText=form?.querySelector('[data-placement-summary-text]');
 const viewButtons=Array.from(root.querySelectorAll('[data-preview-view]'));
 const updatePlacementGuide=()=>{
  const selected=placementInputs.filter(input=>!input.disabled&&input.checked);
  const keys=new Set(selected.map(input=>input.dataset.placement));
  root.querySelectorAll('[data-placement-zone]').forEach(zone=>zone.setAttribute('display',keys.has(zone.dataset.placementZone)?'inline':'none'));
  const shirt=root.querySelector('.tz-shirt');
  if(shirt)shirt.dataset.hasPlacement=String(selected.length>0);
  if(placementSummary&&placementSummaryText){
   placementSummary.hidden=selected.length===0;
   placementSummaryText.textContent=selected.map(input=>input.value).join(' · ');
  }
  if(placementProduct)placementMemory.set(placementProduct,selected.map(input=>input.dataset.placement));
 };
 const setPreviewSide=side=>{
  previewSide=side;
  root.querySelectorAll('[data-preview-side]').forEach(group=>group.setAttribute('display',group.dataset.previewSide===side?'inline':'none'));
  viewButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.previewView===side)));
  const active=previewGroups.find(group=>group.dataset.previewType===placementProduct);
  const button=viewButtons.find(button=>button.dataset.previewView===side);
  if(active&&previewSvg)previewSvg.setAttribute('aria-label',active.dataset.previewLabel+' — '+button.textContent.trim());
 };
 const syncPlacementProduct=type=>{
  if(placementProduct===type){updatePlacementGuide();return;}
  if(placementProduct)placementMemory.set(placementProduct,placementInputs.filter(input=>!input.disabled&&input.checked).map(input=>input.dataset.placement));
  const initial=placementProduct===null?placementInputs.filter(input=>input.checked).map(input=>input.dataset.placement):[];
  const saved=placementMemory.get(type)||initial;
  placementProduct=type;
  placementInputs.forEach(input=>{
   const extra=input.dataset.placement.startsWith('trouser_');
   const available=type!=='collection'&&(!extra||type==='set');
   const label=type==='joggers'?input.dataset.leg:type==='set'&&!extra?input.dataset.set:input.dataset.top;
   input.disabled=!available;
   input.closest('label').hidden=!available;
   input.checked=available&&saved.includes(input.dataset.placement);
   if(available){
    input.value=label;
    input.closest('label').querySelector('[data-placement-label]').textContent=label;
   }
  });
  placementChoiceBox.hidden=type==='collection';
  placementCollectionNote.hidden=type!=='collection';
  setPreviewSide('front');
  updatePlacementGuide();
 };
 placementInputs.forEach(input=>input.addEventListener('change',()=>{
  if(input.checked){
   if(input.dataset.placement==='back'||input.dataset.placement==='trouser_back')setPreviewSide('back');
   else if(input.dataset.placement!=='sleeves')setPreviewSide('front');
  }
  updatePlacementGuide();
 }));
 viewButtons.forEach(button=>button.addEventListener('click',()=>setPreviewSide(button.dataset.previewView)));
 const updateProductPreview=()=>{
  if(!previewSvg)return;
  const type=state.product?(productPreviewTypes[state.product]||'collection'):'tee';
  if(previewSvg.dataset.activePreview===type){syncPlacementProduct(type);return;}
  previewGroups.forEach(group=>{
   const active=group.dataset.previewType===type;
   group.setAttribute('display',active?'inline':'none');
   group.classList.toggle('tz-preview-enter',active);
   if(active){
    previewSvg.setAttribute('aria-label',group.dataset.previewLabel);
    if(previewProductName)previewProductName.textContent=group.dataset.previewName;
   }
  });
  previewSvg.dataset.activePreview=type;
  syncPlacementProduct(type);
 };
 const updateDirection=()=>{
  updateProductPreview();
  const parts=[state.product,state.colour,state.finish].filter(Boolean);
  const box=root.querySelector('.tz-direction');
  const directionText=root.querySelector('[data-direction]');
  const directionInput=root.querySelector('[data-direction-input]');
  if(box&&directionText&&directionInput){
   box.hidden=parts.length===0;
   directionText.textContent=parts.join(' / ');
   directionInput.value=parts.join(' / ');
  }
 };
 root.querySelectorAll('[data-product]').forEach(button=>button.addEventListener('click',()=>{
  state.product=button.dataset.product;
  root.querySelectorAll('[data-product]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  if(productSelect){productSelect.value=state.product;productSelect.dispatchEvent(new Event('change',{bubbles:true}))}
  updateDirection();
 }));
 productSelect?.addEventListener('change',()=>{
  state.product=productSelect.value;
  root.querySelectorAll('[data-product]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.product===state.product)));
  updateDirection();
 });
 root.querySelectorAll('[data-colour]').forEach(button=>button.addEventListener('click',()=>{
  state.colour=button.dataset.colour;
  root.querySelectorAll('[data-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  const shirt=root.querySelector('.tz-shirt');
  shirt.style.setProperty('--garment',button.dataset.hex);
  shirt.style.color=['Charcoal','Navy','Burgundy'].includes(state.colour)?'#f6f1e7':'#394330';
  root.querySelector('[data-colour-name]').textContent=button.getAttribute('aria-label');
  updateDirection();
 }));
 root.querySelectorAll('[data-finish]').forEach(button=>button.addEventListener('click',()=>{
  state.finish=button.dataset.finish;
  root.querySelectorAll('button[data-finish]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  root.querySelector('[data-finish-title]').textContent=button.dataset.title;
  root.querySelector('[data-finish-description]').textContent=button.dataset.description;
  root.querySelector('.tz-shirt').dataset.finish=state.finish;
  updateDirection();
 }));

 const restoreProductPreview=()=>{
  if(productSelect){
   state.product=productSelect.value;
   root.querySelectorAll('[data-product]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.product===state.product)));
  }
  updateDirection();
 };
 window.addEventListener('pageshow',restoreProductPreview);
 restoreProductPreview();

 const brandingInputs=Array.from(root.querySelectorAll('[data-branding]'));
 const brandingGuidance=root.querySelector('[data-brand-guidance]');
 const brandingSummary=form?.querySelector('[data-branding-summary]');
 const brandingSummaryText=form?.querySelector('[data-branding-summary-text]');
 const updateBranding=()=>{
  if(!brandingSummary||!brandingSummaryText)return;
  const choices=brandingInputs.filter(input=>input.checked).map(input=>input.dataset.branding);
  if(brandingGuidance?.checked)choices.push(brandingGuidance.nextElementSibling.textContent.trim());
  brandingSummary.hidden=choices.length===0;
  brandingSummaryText.textContent=choices.join(' · ');
 };
 brandingInputs.forEach(input=>input.addEventListener('change',updateBranding));
 brandingGuidance?.addEventListener('change',updateBranding);
 window.addEventListener('pageshow',updateBranding);
 updateBranding();

 const gallery=root.querySelector('.tz-photo-gallery');
 if(gallery){
  const track=gallery.querySelector('[data-gallery-track]');
  const items=[...gallery.querySelectorAll('[data-gallery-open]')];
  const prev=gallery.querySelector('[data-gallery-prev]');const next=gallery.querySelector('[data-gallery-next]');
  const dialog=gallery.querySelector('[data-gallery-dialog]');const image=gallery.querySelector('[data-gallery-large]');let active=0;
  const counter=index=>String(index+1).padStart(2,'0')+' / '+String(items.length).padStart(2,'0');
  const updateTrack=()=>{
   const gap=parseFloat(getComputedStyle(track).gap)||22;
   const step=(track.firstElementChild?.getBoundingClientRect().width||1)+gap;
   const position=Math.min(items.length-1,Math.max(0,Math.round(track.scrollLeft/step)));
   gallery.querySelector('[data-gallery-position]').textContent=counter(position);
   prev.disabled=track.scrollLeft<3;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;
  };
  const moveTrack=direction=>{
   const gap=parseFloat(getComputedStyle(track).gap)||22;
   const step=(track.firstElementChild?.getBoundingClientRect().width||300)+gap;
   track.scrollBy({left:direction*step,behavior:reduce?'auto':'smooth'});
  };
  prev.addEventListener('click',()=>moveTrack(-1));next.addEventListener('click',()=>moveTrack(1));
  track.addEventListener('scroll',updateTrack,{passive:true});window.addEventListener('resize',updateTrack);updateTrack();
  const showPhoto=index=>{
   active=(index+items.length)%items.length;const item=items[active];
   image.src=item.dataset.full;image.alt=item.querySelector('img').alt||item.dataset.caption;
   gallery.querySelector('[data-gallery-caption]').textContent=item.dataset.caption;
   gallery.querySelector('[data-gallery-modal-count]').textContent=counter(active);
  };
  items.forEach((item,index)=>item.addEventListener('click',()=>{
   showPhoto(index);dialog.showModal();document.documentElement.classList.add('tz-gallery-lock');
  }));
  gallery.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
  gallery.querySelector('[data-gallery-modal-prev]').addEventListener('click',()=>showPhoto(active-1));
  gallery.querySelector('[data-gallery-modal-next]').addEventListener('click',()=>showPhoto(active+1));
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
  dialog.addEventListener('close',()=>document.documentElement.classList.remove('tz-gallery-lock'));
  dialog.addEventListener('keydown',event=>{
   if(event.key==='ArrowRight'){event.preventDefault();showPhoto(active+1)}
   if(event.key==='ArrowLeft'){event.preventDefault();showPhoto(active-1)}
  });
 }

 root.querySelectorAll('.tz-mobile-menu a').forEach(link=>link.addEventListener('click',()=>root.querySelector('.tz-mobile-menu').removeAttribute('open')));
 if(!reduce){
  const progress=root.querySelector('.tz-scroll-progress');let queued=false;
  const paint=()=>{const max=document.documentElement.scrollHeight-window.innerHeight;progress.style.width=(max>0?Math.min(100,Math.max(0,window.scrollY/max*100)):0)+'%';queued=false};
  window.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(paint)}},{passive:true});paint();
 }
 });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initTenzn)}else{initTenzn()}
document.addEventListener('shopify:section:load',initTenzn);


  } catch(e) { console.error(e); }
})();
})();
